import TableToolbarCell from 'shared/components/data-table/TableToolbarCell';
import useCanEditProject from 'shared/projects/useCanEditProject';

const SiteProjectsToolbarCell = ({
  project,
  onDuplicate,
  onUnarchive,
  onArchive,
  onUnconfidential,
  onConfidential,
  onUnfinal,
  onFinal
}) => {
  const canEdit = useCanEditProject(project ? { userId: project.createdById, sharedLevel: project.sharedLevel } : null);

  return (
    <TableToolbarCell>
      <TableToolbarCell.MenuItem itemText="Duplicate" onClick={() => onDuplicate(project.id)} />
      {!canEdit ? null : project?.isArchived ? (
        <TableToolbarCell.MenuItem itemText="Unarchive" onClick={() => onUnarchive(project.id)} />
      ) : (
        <TableToolbarCell.MenuItem itemText="Archive" onClick={() => onArchive(project.id)} />
      )}
      {!canEdit ? null : project?.isConfidential ? (
        <TableToolbarCell.MenuItem itemText="Undo Confidential" onClick={() => onUnconfidential(project.id)} />
      ) : (
        <TableToolbarCell.MenuItem itemText="Mark Confidential" onClick={() => onConfidential(project.id)} />
      )}
      {!canEdit ? null : project?.isFinal ? (
        <TableToolbarCell.MenuItem itemText="Undo Final" onClick={() => onUnfinal(project.id)} />
      ) : (
        <TableToolbarCell.MenuItem itemText="Mark as Final" onClick={() => onFinal(project.id)} />
      )}
    </TableToolbarCell>
  );
};

export default SiteProjectsToolbarCell;
